import type { OperationVariables } from "@apollo/client/core/index.js";
import type {
  QueryHookOptions,
  QueryResult,
} from "@apollo/client/react/index.js";
import { useQuery } from "@apollo/client/react/hooks/index.js";

export const useQueryWithPreviousData = <
  TData = any,
  TVariables extends OperationVariables = any,
>(
  query: any,
  options?: QueryHookOptions<TData, TVariables>,
): QueryResult<TData, TVariables> => {
  const result = useQuery<TData, TVariables>(query, options);
  if ("previousData" in result && result.loading && !result.data) {
    return {
      ...result,
      data: result.previousData,
    };
  }
  return result;
};
